import { moduleProviderFactory } from 'core/providers';
import { ShipmentCost } from 'modules/shipment-cost/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.shipment-cost',
				pattern: '/shipment-cost',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.shipment-cost',
						pattern: '',
						authorization: 'shipmentCostSection.full',
						component: ShipmentCost,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/shipment-cost/config.js